<template>
  <div class="RentInformationDetails">
    <!-- 当前位置 -->
    <Breadcrumb></Breadcrumb>
    <!-- 详情 -->
    <Details></Details>
  </div>
</template>

<script>
import Breadcrumb from '@/views/LabourService/RentInformationDetails/Breadcrumb'// 当前位置
import Details from '@/views/LabourService/RentInformationDetails/Details'// 详情
export default {
  name: 'RentInformationDetails',
  components: {
    Breadcrumb,
    Details
  },
  data () {
    return {

    }
  },
  mounted () {},
  // 方法
  methods: {

  },
  watch: {

  },
  created () {}
}
</script>

<style>

</style>
